import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as shoppingCartActions from '~/store/legacy/actions/shoppingCartActions';
import * as shoppingCartSelectors from '~/store/legacy/selector/shoppingCartSelectors.js';

export default CannedTipsButtons;

//TODO: Use theme colors
const useStyles = makeStyles({
  cannedTipButton: {
    borderLeft: '1px solid #E1E1E1',
    borderBottom: '2px solid transparent',
    borderRadius: 0,
    padding: '12px 0',

    '&:first-of-type': {
      borderLeft: 'none',
    },
  },
  label: {
    fontSize: '1.1em',
  },
  selected: {
    borderBottomColor: '#e00051',
  },
});

function CannedTipsButtons() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const uiTips = useSelector(shoppingCartSelectors.uiTips);

  function onTipSelected(option) {
    dispatch(
      shoppingCartActions.onTipsInputChangeAction({
        inputType: option.type,
        value: option.value,
      })
    );
  }

  return (
    <>
      {uiTips.options &&
        uiTips.options.map((option) => (
          <Button
            key={option.value}
            classes={{
              root: classNames([
                classes.cannedTipButton,
                uiTips.value === option.value ? classes.selected : null,
              ]),
              label: classes.label,
            }}
            onClick={() => onTipSelected(option)}>
            {option.display}
          </Button>
        ))}
    </>
  );
}
